export default {"src":"/_next/static/media/CSR-Mind-Map.e597102e.svg","height":601,"width":1506,"blurWidth":0,"blurHeight":0};